import React from 'react';
import {
  ProductStatusCssClasses,
  ProductStatusTitles,
} from '../../ProductsUIHelpers';

export const StatusColumnFormatter = (cellContent, row) => {
  return (
    <span
      className={`label label-lg label-light-${
        ProductStatusCssClasses[row.Status - 1]
      } label-inline`}
    >
      {ProductStatusTitles[row.Status - 1]}
    </span>
  );
};
